<div class="modal-content border-0 shadow-lg">
    <!-- HEADER -->
    <div class="modal-header border-bottom py-4 px-5" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
        <div>
            <h4 class="modal-title mb-1 fw-semibold" style="color: #2E3643; letter-spacing: -0.5px;">
                Nueva Orden de Mantenimiento
            </h4>
            <small style="color: #7B8298;">Registro de mantenimiento vehicular</small>
        </div>
        <button type="button" class="btn-close" style="font-size: 0.8rem;" (click)="close()" [disabled]="isSubmitting"></button>
    </div>

    <!-- BODY -->
    <div class="modal-body px-5 py-4" style="max-height: 72vh; overflow-y: auto; background-color: #fafbfc;">
        <form [formGroup]="maintenanceForm" novalidate>

            <!-- DATOS DEL VEHÍCULO -->
            <div class="card border-0 mb-4" style="background-color: white; box-shadow: 0 2px 12px rgba(46, 54, 67, 0.06);">
                <div class="card-body p-4">
                    <!-- Header de la card -->
                    <div class="d-flex align-items-center mb-4 pb-3 border-bottom">
                        <div class="rounded-circle d-flex align-items-center justify-content-center me-3"
                             style="width: 40px; height: 40px; background-color: #f59e0b; opacity: 0.1;">
                            <i class="bi bi-car-front" style="font-size: 1.2rem; color: #f59e0b;"></i>
                        </div>
                        <div>
                            <h6 class="mb-0 fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Datos del Vehículo</h6>
                            <small style="color: #7B8298; font-size: 0.8rem;">Información del vehículo a mantener</small>
                        </div>
                    </div>

                    <!-- Loading con skeleton -->
                    <div *ngIf="isLoadingVehicle" class="py-3">
                        <div class="d-flex align-items-center mb-4">
                            <div class="spinner-border me-3" style="width: 2rem; height: 2rem; border-width: 3px; color: #f59e0b;" role="status">
                                <span class="visually-hidden">Cargando...</span>
                            </div>
                            <div>
                                <div class="fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Cargando datos del vehículo</div>
                                <small style="color: #7B8298; font-size: 0.85rem;">Obteniendo información...</small>
                            </div>
                        </div>

                        <!-- Skeleton loader -->
                        <div class="row g-4">
                            <div class="col-md-6">
                                <div class="skeleton-box" style="height: 60px; border-radius: 8px;"></div>
                            </div>
                            <div class="col-md-6">
                                <div class="skeleton-box" style="height: 60px; border-radius: 8px;"></div>
                            </div>
                            <div class="col-md-6">
                                <div class="skeleton-box" style="height: 60px; border-radius: 8px;"></div>
                            </div>
                            <div class="col-md-6">
                                <div class="skeleton-box" style="height: 60px; border-radius: 8px;"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Datos cargados -->
                    <div *ngIf="!isLoadingVehicle && vehicleData" class="row g-4">
                        <div class="col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Placa</small>
                                <div class="fw-bold" style="color: #2E3643; font-size: 1.25rem; letter-spacing: 0.5px;">{{ vehicleData.plates }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">N/S</small>
                                <div class="fw-bold" style="color: #2E3643; font-size: 1.25rem;">{{ vehicleData.ns }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Marca</small>
                                <div style="color: #2E3643; font-size: 1rem;">{{ vehicleData.brand }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Modelo</small>
                                <div style="color: #2E3643; font-size: 1rem;">{{ vehicleData.model }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- KILOMETRAJE -->
            <div class="mb-3">
                <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                    Kilometraje <span style="color: #ef4444;">*</span>
                </label>
                <input
                        type="text"
                        class="form-control"
                        id="km"
                        formControlName="km"
                        placeholder="Ej: 50000"
                        style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;"
                        [class.is-invalid]="maintenanceForm.get('km')?.touched && maintenanceForm.get('km')?.errors">
                <div class="invalid-feedback">
                    El kilometraje es requerido
                </div>
            </div>

            <!-- PROVEEDOR Y TIPO DE MANTENIMIENTO -->
            <div class="row g-3 mb-3">
                <!-- PROVEEDOR -->
                <div class="col-lg-6">
                    <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                        Proveedor <span style="color: #ef4444;">*</span>
                    </label>

                    <!-- Loading skeleton para select -->
                    <div *ngIf="isLoadingProviders" class="skeleton-box" style="height: 45px; border-radius: 6px;"></div>

                    <!-- Select de proveedores -->
                    <select
                            *ngIf="!isLoadingProviders"
                            class="form-select"
                            id="providerId"
                            formControlName="providerId"
                            style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;"
                            [class.is-invalid]="maintenanceForm.get('providerId')?.touched && maintenanceForm.get('providerId')?.errors">
                        <option [value]="null">Seleccione un proveedor</option>
                        <option *ngFor="let provider of providers" [value]="provider.id">
                            {{ provider.value }}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        Debe seleccionar un proveedor
                    </div>
                </div>

                <!-- TIPO DE MANTENIMIENTO -->
                <div class="col-lg-6">
                    <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                        Tipo de Mantenimiento <span style="color: #ef4444;">*</span>
                    </label>
                    <select
                            class="form-select"
                            id="maintenanceType"
                            formControlName="maintenanceType"
                            style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;"
                            [class.is-invalid]="maintenanceForm.get('maintenanceType')?.touched && maintenanceForm.get('maintenanceType')?.errors">
                        <option value="preventivo">Preventivo</option>
                        <option value="correctivo">Correctivo</option>
                    </select>
                    <div class="invalid-feedback">
                        Debe seleccionar el tipo de mantenimiento
                    </div>
                </div>
            </div>

            <!-- FECHA DE AGENDA Y SOLICITANTE -->
            <div class="row g-3 mb-3">
                <!-- FECHA DE AGENDA -->
                <div class="col-lg-6">
                    <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                        Fecha de Agenda <span style="color: #7B8298; font-size: 0.8rem;">(Opcional)</span>
                    </label>
                    <input
                            type="date"
                            class="form-control"
                            id="scheduledDate"
                            formControlName="scheduledDate"
                            style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;">
                </div>

                <!-- SOLICITANTE -->
                <div class="col-lg-6">
                    <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                        Solicitante <span style="color: #ef4444;">*</span>
                    </label>
                    <input
                            type="text"
                            class="form-control"
                            id="requestedByName"
                            formControlName="requestedByName"
                            placeholder="Nombre del solicitante"
                            style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;"
                            [class.is-invalid]="maintenanceForm.get('requestedByName')?.touched && maintenanceForm.get('requestedByName')?.errors">
                    <div class="invalid-feedback">
                        El nombre del solicitante es requerido
                    </div>
                </div>
            </div>

            <!-- ORDEN DE SERVICIO -->
            <div class="mb-3">
                <label class="form-label" style="color: #2E3643; font-weight: 500; font-size: 0.9rem;">
                    Orden de Servicio <span style="color: #7B8298; font-size: 0.8rem;">(Opcional)</span>
                </label>
                <input
                        type="number"
                        class="form-control"
                        id="serviceId"
                        formControlName="serviceId"
                        placeholder="ID de servicio relacionado"
                        style="border: 1.5px solid #dee2e6; padding: 0.65rem 1rem; font-size: 0.95rem;">
            </div>

            <!-- DESCUENTO A OPERADOR -->
            <div class="card border-0 mb-3" style="background-color: white; box-shadow: 0 2px 12px rgba(46, 54, 67, 0.06);">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center mb-2">
                        <div class="rounded-circle me-2" style="width: 8px; height: 8px; background-color: #8D9FB3;"></div>
                        <h6 class="mb-0 fw-semibold" style="color: #2E3643; font-size: 0.9rem;">Descuento a Operador</h6>
                        <small class="ms-2" style="color: #7B8298; font-size: 0.8rem;">(Opcional)</small>
                    </div>

                    <div class="row g-2">
                        <div class="col-lg-6 col-12">
                            <label class="form-label mb-1" style="color: #7B8298; font-size: 0.85rem;">Tipo</label>
                            <select class="form-select form-select-sm" id="operatorDiscountType" formControlName="operatorDiscountType"
                                    style="border: 1.5px solid #dee2e6; padding: 0.5rem 0.75rem; font-size: 0.9rem;">
                                <option value="ninguno">Sin descuento</option>
                                <option value="monto">Monto fijo</option>
                                <option value="porcentaje">Porcentaje</option>
                            </select>
                        </div>

                        <div class="col-lg-6 col-12" *ngIf="maintenanceForm.get('operatorDiscountType')?.value !== 'ninguno'">
                            <label class="form-label mb-1" style="color: #7B8298; font-size: 0.85rem;">Valor</label>
                            <div class="input-group input-group-sm">
                                <span class="input-group-text" style="background-color: #f8f9fa; border: 1.5px solid #dee2e6; color: #7B8298;">
                                    <i class="bi" [ngClass]="maintenanceForm.get('operatorDiscountType')?.value === 'monto' ? 'bi-currency-dollar' : 'bi-percent'"></i>
                                </span>
                                <input
                                        type="number"
                                        class="form-control"
                                        id="operatorDiscountValue"
                                        formControlName="operatorDiscountValue"
                                        [placeholder]="maintenanceForm.get('operatorDiscountType')?.value === 'monto' ? 'Ej: 500.00' : 'Ej: 10'"
                                        step="0.01"
                                        min="0"
                                        style="border: 1.5px solid #dee2e6; padding: 0.5rem 0.75rem; font-size: 0.9rem;">
                            </div>
                        </div>
                    </div>

                    <!-- Indicador visual del descuento aplicado -->
                    <div *ngIf="maintenanceForm.get('operatorDiscountType')?.value !== 'ninguno' && maintenanceForm.get('operatorDiscountValue')?.value > 0"
                         class="mt-2 p-2"
                         style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); border-radius: 6px; border-left: 3px solid #8D9FB3;">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-tag-fill me-2" style="color: #8D9FB3; font-size: 1rem;"></i>
                            <div>
                                <small style="color: #7B8298; font-size: 0.7rem; display: block;">Descuento configurado</small>
                                <span style="color: #2E3643; font-weight: 600; font-size: 0.95rem;">
                                    {{ maintenanceForm.get('operatorDiscountType')?.value === 'monto'
                                    ? '$' + maintenanceForm.get('operatorDiscountValue')?.value.toFixed(2)
                                    : maintenanceForm.get('operatorDiscountValue')?.value + '%' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CONCEPTOS DE MANTENIMIENTO -->
            <div class="card border-0 mb-3" style="background-color: white; box-shadow: 0 2px 12px rgba(46, 54, 67, 0.06);">
                <div class="card-header border-bottom py-2 px-3" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <div class="me-2" style="width: 3px; height: 18px; background-color: #f59e0b;"></div>
                            <h6 class="mb-0 fw-semibold" style="color: #2E3643; font-size: 0.9rem;">
                                Conceptos de Mantenimiento
                            </h6>
                        </div>
                        <span class="badge" style="background-color: #f59e0b; color: white; font-size: 0.7rem; padding: 0.3rem 0.6rem;">
                            {{ itemsArray.length }} concepto(s)
                        </span>
                    </div>
                </div>
                <div class="card-body p-3">
                    <div formArrayName="items">
                        <div *ngFor="let item of itemsArray.controls; let i = index"
                             [formGroupName]="i"
                             class="row g-2 mb-3 pb-2"
                             [class.border-bottom]="i < itemsArray.length - 1">

                            <div class="col-lg-7 col-12">
                                <label class="form-label mb-1" style="color: #7B8298; font-size: 0.8rem;">
                                    Concepto {{ i + 1 }} <span style="color: #ef4444;">*</span>
                                </label>

                                <!-- Loading skeleton para select de conceptos -->
                                <div *ngIf="isLoadingConcepts" class="skeleton-box" style="height: 38px; border-radius: 6px;"></div>

                                <!-- Select de conceptos -->
                                <select
                                        *ngIf="!isLoadingConcepts"
                                        class="form-select form-select-sm"
                                        formControlName="conceptId"
                                        style="border: 1.5px solid #dee2e6; padding: 0.5rem 0.75rem; font-size: 0.85rem;"
                                        [class.is-invalid]="item.get('conceptId')?.touched && item.get('conceptId')?.errors">
                                    <option [value]="null">Seleccione un concepto</option>
                                    <option *ngFor="let concept of concepts" [value]="concept.id">
                                        {{ concept.value }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Debe seleccionar un concepto
                                </div>
                            </div>

                            <div class="col-lg-4 col-10">
                                <label class="form-label mb-1" style="color: #7B8298; font-size: 0.8rem;">
                                    Monto <span style="color: #ef4444;">*</span>
                                </label>
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text" style="background-color: #f8f9fa; border: 1.5px solid #dee2e6; color: #7B8298; font-size: 0.85rem;">
                                        $
                                    </span>
                                    <input
                                            type="number"
                                            class="form-control"
                                            formControlName="amount"
                                            placeholder="0.00"
                                            step="0.01"
                                            min="0.01"
                                            style="border: 1.5px solid #dee2e6; padding: 0.5rem 0.75rem; font-size: 0.85rem;"
                                            [class.is-invalid]="item.get('amount')?.touched && item.get('amount')?.errors">
                                    <div class="invalid-feedback">
                                        El monto es requerido
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-1 col-2 d-flex align-items-end justify-content-end">
                                <button
                                        type="button"
                                        class="btn btn-sm mb-1"
                                        style="border: 1.5px solid #ef4444; color: #ef4444; padding: 0.4rem 0.5rem;"
                                        (click)="removeItem(i)"
                                        [disabled]="itemsArray.length === 1"
                                        title="Eliminar concepto">
                                    <i class="bi bi-trash" style="font-size: 0.9rem;"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button
                            type="button"
                            class="btn btn-sm px-3 py-2 w-100 w-lg-auto"
                            style="background-color: white; border: 1.5px solid #f59e0b; color: #f59e0b; font-weight: 500; font-size: 0.85rem;"
                            (click)="addItem()">
                        <i class="bi bi-plus-circle me-1"></i>
                        Agregar Concepto
                    </button>
                </div>
            </div>

            <!-- TOTALES -->
            <div class="card border-0" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); box-shadow: 0 2px 12px rgba(46, 54, 67, 0.06);">
                <div class="card-body p-4">
                    <div class="row mb-2">
                        <div class="col-6 text-end">
                            <span style="color: #7B8298; font-size: 0.9rem;">Subtotal:</span>
                        </div>
                        <div class="col-6">
                            <span style="color: #2E3643; font-weight: 500; font-size: 1rem;">${{ calculateSubtotal().toFixed(2) }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-6 text-end">
                            <span style="color: #7B8298; font-size: 0.9rem;">IVA (16%):</span>
                        </div>
                        <div class="col-6">
                            <span style="color: #2E3643; font-weight: 500; font-size: 1rem;">${{ calculateIVA().toFixed(2) }}</span>
                        </div>
                    </div>
                    <div class="row pt-3 border-top">
                        <div class="col-6 text-end">
                            <span style="color: #2E3643; font-weight: 600; font-size: 1.1rem;">Total:</span>
                        </div>
                        <div class="col-6">
                            <span style="color: #f59e0b; font-weight: 700; font-size: 1.5rem;">${{ calculateTotal().toFixed(2) }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer border-top py-4 px-5" style="background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);">
        <button
                type="button"
                class="btn px-4 py-2"
                style="background-color: white; border: 1.5px solid #dee2e6; color: #2E3643; font-weight: 500; letter-spacing: 0.3px; transition: all 0.2s ease;"
                onmouseover="this.style.borderColor='#8D9FB3'; this.style.color='#8D9FB3'"
                onmouseout="this.style.borderColor='#dee2e6'; this.style.color='#2E3643'"
                (click)="close()"
                [disabled]="isSubmitting">
            Cancelar
        </button>
        <button
                type="button"
                class="btn px-4 py-2"
                style="background-color: #f59e0b; border: none; color: white; font-weight: 500; letter-spacing: 0.3px; transition: all 0.2s ease;"
                onmouseover="this.style.backgroundColor='#d97706'"
                onmouseout="this.style.backgroundColor='#f59e0b'"
                (click)="submit()"
                [disabled]="isSubmitting || maintenanceForm.invalid">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isSubmitting" class="bi bi-check-circle me-2"></i>
            {{ isSubmitting ? 'Creando...' : 'Crear Orden de Mantenimiento' }}
        </button>
    </div>
</div>
